module.exports = __webpack_public_path__ + "static/media/tap_07_img05.add928ff.png";